
import _ from "lodash";
import { TextStyleKeys, ContainerStyleKeys, TableDataStyleKeys } from "@Utilities/enum"

import useWindowResize from "@Functions/useWindowResize.js";

export default function () {
    let classArr = [];
    let styleArr = [];

    // START OF DETECTING DEVICE
    const { isDesktop } = useWindowResize();
    // END OF DETECTING DEVICE

    const processClassArr = (data, key) => {
        if (_.has(data, key) && data[key]) {
            classArr.push(`${data[key]}`)
        }
    }
    const processStyleArr = (item) => {
        styleArr.push(item)
    }

    // START OF HEADER STYLES
    const onProcessTextStyle = (data) => {
        if (_.isEmpty(data)) return
        classArr = [];
        styleArr = [];
        _.forEach(TextStyleKeys, i => {
            switch (i) {
            case 'align':
                if (_.includes(data[i], 'text')) {
                    processClassArr(data, i);
                } else {
                    processStyleArr(`text-align: ${data[i]};`)
                }
                break;
            case 'fontSize':
                if (_.isNumber(data[i])) {
                    processStyleArr(`font-size: ${data[i]}px;`)
                } else {
                    processClassArr(data, i);
                }
                break;
            case 'color':
                if (_.includes(data[i], "#")) {
                    processStyleArr(`color: ${data[i]};`)
                } else {
                    processClassArr(data, i);
                }
                break;
            case 'fontStyle':
                if (_.isNumber(data[i])) {
                    processStyleArr(`font-weight: ${data[i]};`)
                } else {
                    processClassArr(data, i);
                }
                break;
            }
        })
        return {
            class: classArr.join(' '),
            style: styleArr.join(' '),
        }
    }
    const setHeaderStyle = (style) => {
        let headerStyle = {}
        if (!_.isEmpty(style)) {
            headerStyle = {
                icon: style.icon,
                title: onProcessTextStyle(style.title),
                description: onProcessTextStyle(style.description),
            }
        }
        return headerStyle;
    }
    const setBorderStyle = (style) => {
        if (_.isEmpty(style)) return

        if (!_.isEmpty(style.border)) {
            let item = {
                class: `border-${style.border.color}` || 'border-gray-200',
                style: ''
            }

            if (_.includes(style.border, "#")) {
                item = {
                    class: '',
                    style: `border-color: ${style.border.color};`
                }
            }

            return item;
        }

    }
    // END OF HEADER STYLES

    // START OF CONTAINER STYLES
    const setContainerClass = (data) => {
        if (_.isEmpty(data)) return
        classArr = [];
        styleArr = [];

        _.forEach(ContainerStyleKeys, i => {
            switch (i) {
            case 'width':
                if (_.isNumber(data[i])) {
                    processStyleArr(`grid-column: span ${data[i]} / span ${data[i]};`)
                    if (!isDesktop.value) {
                        styleArr = [];
                        processStyleArr(`grid-column: span 12 / span 12;`);
                    }
                } else {
                    processClassArr(data, i);
                    if (!isDesktop.value) {
                        classArr = [];
                        classArr.push(`col-span-12`);
                    }
                }
                break;
            case 'align':
                if (_.includes(data[i], "items")) {
                    processClassArr(data, i);
                } else {
                    processStyleArr(`align-items: ${data[i]};`)
                }
                break;
            case 'position':
                if (_.includes(data[i], "justify")) {
                    processClassArr(data, i);
                } else {
                    processStyleArr(`justify-content: ${data[i]};`)
                }
                break;
            case 'bgColor':
                if (!_.includes(data[i], "#")) {
                    processClassArr(data, i);
                } else {
                    processStyleArr(`background-color: ${data[i]};`)
                }
                break;
            }
        })
        return {
            class: classArr.join(' '),
            style: styleArr.join(' '),
        }
    }
    // END OF CONTAINER STYLES

    // START OF SINGLE STAT DATA STYLES
    const setDataStyle = (style) => {
        return {
            title: onProcessTextStyle(style.title),
            description: onProcessTextStyle(style.description),
            content: onProcessTextStyle(style.data),
        }
    }
    // END OF SINGLE STAT DATA STYLES

    // START OF ICON STYLES
    const getIconStyles = (value) => {
        let item;
        const { color, size } = value;
        let arr = [];
        if (_.includes(color, "#")) {
            item = {
                class: `${size}`,
                style: `color: ${color}`,
            }

            if (_.isNumber(size)) {
                item = {
                    style: `color: ${color}; height: ${size}px; width: ${size}px`,
                }
            }

        } else {
            _.forEach(value, (value, key) => {
                if (key !== 'name' && value) {
                    arr.push(value)
                }
            })

            item = {
                class: arr.join(' '),
            }

            if (_.isNumber(size)) {
                item = {
                    class: `${color}`,
                    style: `height: ${size}px; width: ${size}px`,
                }
            }
        }
        return item;
    }
    // END OF ICON STYLES

    // START OF TABLE FONT STYLES
    const onSetFontStyle = (data) => {
        if (_.isEmpty(data)) return
        classArr = [];
        styleArr = [];
        _.forEach(TableDataStyleKeys, i => {
            switch (i) {
            case 'fontSize':
                if (_.isNumber(data[i])) {
                    processStyleArr(`font-size: ${data[i]}px;`)
                } else {
                    processClassArr(data, i);
                }
                break;
            case 'fontColor':
                if (_.includes(data[i], "#")) {
                    processStyleArr(`color: ${data[i]};`)
                } else {
                    processClassArr(data, i);
                }
                break;
            }
        })
        return {
            class: classArr.join(' '),
            style: styleArr.join(' '),
        }
    }
    // END OF TABLE FONT STYLES

    return {
        setContainerClass,
        getIconStyles,
        setHeaderStyle,
        setBorderStyle,
        setDataStyle,
        onSetFontStyle,
    }
}